import { ReactNode, useCallback, useState } from 'react';
import { ExceptionalOpeningHoursFormContext } from './useExceptionalOpeningHoursFormContext';
import { ResourceExceptionalOpeningHours } from '@jooxter/api';

export const ExceptionalOpeningHoursFormProvider = ({ children }: { children: ReactNode }) => {
  const [showExceptionalOpeningHours, setShowExceptionalOpeningHours] =
    useState<ResourceExceptionalOpeningHours | null>(null);

  const showExceptionalOpeningHoursDetails = useCallback((exceptionalOpeningHours: ResourceExceptionalOpeningHours) => {
    setShowExceptionalOpeningHours(exceptionalOpeningHours);
  }, []);

  const closeExceptionalOpeningHoursDetails = useCallback(() => {
    setShowExceptionalOpeningHours(null);
  }, []);

  return (
    <ExceptionalOpeningHoursFormContext.Provider
      value={{ showExceptionalOpeningHours, showExceptionalOpeningHoursDetails, closeExceptionalOpeningHoursDetails }}
    >
      {children}
    </ExceptionalOpeningHoursFormContext.Provider>
  );
};
